import React from "react";
import moment from "moment";
import { Table, Column, Cell } from "fixed-data-table-2";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button
} from "@material-ui/core";

import { Row, Col } from "react-flexbox-grid";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";

const alteredTime = oldTime =>
  `${moment(oldTime)
    .subtract(1, "seconds")
    .format("YYYY-MM-DD HH:mm:ss")}`;

const ChangeFormOrderModal = props => {
  if (!props.changeModalOpen || props.changeOrderSubmissionID === undefined)
    return <div />;

  const rowStyle = i =>
    props.formData[i].submission_id === props.modalData.submission_id && {
      color: "blue"
    };

  const selectedPredecessorStyle = i =>
    i === props.changeOrderSubmissionID && {
      color: "#BBBBBB",
      fontStyle: "italic"
    };

  const styles = {
    tableFont: {
      fontFamily: "Roboto"
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      className="clickableCell"
      open={props.changeModalOpen}
      scroll="body"
      keyboardFocused
      onClose={props.onChangeOrderClose}
    >
      <DialogTitle>Change Form Order</DialogTitle>
      <DialogContent>
        <Row>
          <Col xs={12}>
            <DialogContentText>
              <br />
              To change the order of <b>{props.modalData.form_name}</b>, click
              on the form that you would like this form to appear before.
              <p>
                Current time for this submission is{" "}
                {moment(props.modalData.submitted_dt).format(
                  "YYYY-MM-DD H:mm:ss"
                )}
              </p>
              <b>
                <p>
                  {props.changeOrderSubmissionID >= 0
                    ? `\r\n\r\nNew submission time: ${alteredTime(
                        props.formData[props.changeOrderSubmissionID]
                          .submitted_dt
                      )}`
                    : null}
                </p>
              </b>
            </DialogContentText>
          </Col>
        </Row>
        <Row style={styles.tableFont}>
          <Col xs={12}>
            <AutoSizer disableHeight>
              {({ width }) => (
                <Table
                  onRowClick={(e, i) =>
                    props.formData[i].submission_id !==
                      props.modalData.submission_id &&
                    props.onSubmissionIDChange(i)
                  }
                  rowHeight={50}
                  rowsCount={props.formData.length}
                  maxHeight={window.innerHeight * 0.4}
                  headerHeight={50}
                  width={width}
                >
                  <Column
                    columnKey="date_submitted"
                    width={100}
                    header={<Cell> Submitted </Cell>}
                    cell={({ rowIndex }) => (
                      <Cell
                        style={
                          rowStyle(rowIndex) ||
                          selectedPredecessorStyle(rowIndex)
                        }
                      >
                        {rowIndex === props.changeOrderSubmissionID && "\u2191"}
                        {rowIndex === props.changeOrderSubmissionID - 1 &&
                          "\u2193"}

                        {moment(props.formData[rowIndex].submitted_dt).format(
                          "YYYY-MM-DD H:mm:ss"
                        )}
                      </Cell>
                    )}
                    flexGrow={1}
                  />

                  <Column
                    columnKey="submission_id"
                    width={100}
                    header={<Cell> Submission ID </Cell>}
                    cell={({ rowIndex }) => (
                      <Cell
                        style={
                          rowStyle(rowIndex) ||
                          selectedPredecessorStyle(rowIndex)
                        }
                      >
                        {props.formData[rowIndex].submission_id}
                      </Cell>
                    )}
                    flexGrow={1}
                  />

                  <Column
                    columnKey="source"
                    width={100}
                    header={<Cell> Source </Cell>}
                    cell={({ rowIndex }) => (
                      <Cell
                        style={
                          rowStyle(rowIndex) ||
                          selectedPredecessorStyle(rowIndex)
                        }
                      >
                        {props.formData[rowIndex].submission_source}
                      </Cell>
                    )}
                    flexGrow={1}
                  />

                  <Column
                    columnKey="submission_device"
                    width={100}
                    header={<Cell> Device </Cell>}
                    cell={({ rowIndex }) => (
                      <Cell
                        style={
                          rowStyle(rowIndex) ||
                          selectedPredecessorStyle(rowIndex)
                        }
                      >
                        {props.formData[rowIndex].submission_device}
                      </Cell>
                    )}
                    flexGrow={1}
                  />

                  <Column
                    columnKey="formName"
                    width={100}
                    header={<Cell> Form Name </Cell>}
                    cell={({ rowIndex }) => (
                      <Cell
                        style={
                          rowStyle(rowIndex) ||
                          selectedPredecessorStyle(rowIndex)
                        }
                      >
                        {props.formData[rowIndex].form_name}
                      </Cell>
                    )}
                    flexGrow={1}
                  />
                </Table>
              )}
            </AutoSizer>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={props.onSaveChangeFormOrder}>
          Save
        </Button>
        <Button color="primary" onClick={props.onChangeOrderClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChangeFormOrderModal.propTypes = {
  modalData: PropTypes.shape({
    submitted_dt: PropTypes.string,
    submission_id: PropTypes.string,
    form_name: PropTypes.string
  }).isRequired,
  onSubmissionIDChange: PropTypes.func.isRequired,
  changeOrderSubmissionID: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSaveChangeFormOrder: PropTypes.func.isRequired,
  onChangeOrderClose: PropTypes.func.isRequired,
  changeModalOpen: PropTypes.bool.isRequired
};

export default ChangeFormOrderModal;
